import { StorageBackendForm } from '@/components/admin/StorageBackendForm';
import { Button } from '@/components/ui/button';
import { ApiError, api } from '@/lib/api';
import type { StorageConfigInput } from '@innermate/shared';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';

interface Props {
  onAdvance: () => void;
}

export function StepStorage({ onAdvance }: Props) {
  const [serverError, setServerError] = useState<string | null>(null);
  const [testResult, setTestResult] = useState<null | { ok: boolean; message: string }>(null);

  const saveMut = useMutation({
    mutationFn: (body: StorageConfigInput) =>
      api.onboardingStorage({ action: 'save', config: body }),
    onSuccess: () => onAdvance(),
    onError: (err: unknown) => {
      setServerError(err instanceof ApiError ? err.message : '알 수 없는 오류');
    },
  });

  const skipMut = useMutation({
    mutationFn: () => api.onboardingStorage({ action: 'skip' }),
    onSuccess: () => onAdvance(),
    onError: (err: unknown) => {
      setServerError(err instanceof ApiError ? err.message : '알 수 없는 오류');
    },
  });

  const testMut = useMutation({
    mutationFn: (body: StorageConfigInput) =>
      api.onboardingStorageTest({ action: 'save', config: body }),
    onSuccess: (res) => setTestResult({ ok: res.ok, message: res.message }),
    onError: (err: unknown) =>
      setTestResult({
        ok: false,
        message: err instanceof ApiError ? err.message : '알 수 없는 오류',
      }),
  });

  const busy = saveMut.isPending || skipMut.isPending || testMut.isPending;

  return (
    <div className="space-y-4">
      <p className="text-sm text-foreground-muted">
        파일 업로드 (엑셀 등) 가 저장될 백엔드를 등록합니다. 나중에 관리자 메뉴에서 변경할 수
        있으므로 지금은 건너뛰어도 됩니다.
      </p>
      <StorageBackendForm
        initialType="s3"
        onSubmit={(body) => {
          setServerError(null);
          saveMut.mutate(body);
        }}
        onTest={(body) => {
          setTestResult(null);
          testMut.mutate(body);
        }}
        busy={busy}
        testing={testMut.isPending}
        testResult={testResult}
        serverError={serverError}
        submitLabel={saveMut.isPending ? '저장 중…' : '저장하고 다음'}
        leftAction={
          <Button
            type="button"
            variant="secondary"
            onClick={() => skipMut.mutate()}
            disabled={busy}
          >
            건너뛰기
          </Button>
        }
      />
    </div>
  );
}
